/**
 * Backend environment validation
 * @type {"dev" | "stg" | "prod"}
 */
const VALID_ENV = ["dev", "stg", "prod"];
let BACKEND_ENV = import.meta.env.VITE_BACKEND_ENV || "stg";

// Debug logging (only in dev)
if (import.meta.env.DEV) {
  console.log("=== CONFIG DEBUG ===");
  console.log("BACKEND_API_URL:", import.meta.env.VITE_BACKEND_API_URL);
  console.log("BACKEND_ENV:", import.meta.env.VITE_BACKEND_ENV);
  console.log("ROUTE_BASE_PATH:", import.meta.env.VITE_ROUTE_BASE_PATH);
  console.log("MODE:", import.meta.env.MODE);
  console.log("===================");
}

// Force valid value
if (!VALID_ENV.includes(BACKEND_ENV)) {
  console.warn(`Invalid VITE_BACKEND_ENV: ${BACKEND_ENV}. Falling back to "stg"`);
  BACKEND_ENV = "stg";
}

/**
 * Backend API configuration
 * @typedef {Object} BackendRoute
 * @property {string} root - Base route path
 * @property {string} login - Login endpoint
 * @property {string} callback - Callback endpoint
 */

/**
 * @typedef {Object} BackendConfig
 * @property {"dev" | "stg" | "prod"} stage - Current environment stage
 * @property {Object} route - API route configuration
 * @property {string} route.root - Base API path (stage-aware)
 * @property {Object} route.register - Registration endpoints
 * @property {string} route.register.root - Registration root path
 * @property {Object} route.singpass - Singpass authentication endpoints
 * @property {string} route.singpass.login - Singpass login endpoint
 * @property {string} route.singpass.callback - Singpass callback endpoint
 */

/** @type {BackendConfig} */
export const backend = {
  stage: BACKEND_ENV,
  route: {
    root: `/${BACKEND_ENV}/palmpass/v1/api`,
    register: { root: "/register" },
    singpass: {
      login: "/login",
      callback: "/callback",
    },
  },
};

/**
 * Frontend routing configuration
 * @typedef {Object} FrontendRoute
 * @property {string} root - Base route path
 */

/**
 * @typedef {Object} FrontendConfig
 * @property {Object} route - Frontend route configuration
 * @property {string} route.root - Base frontend path
 * @property {Object} route.legal - Legal page routes
 * @property {string} route.legal.root - Legal root path
 * @property {Object} route.register - Registration flow routes
 * @property {string} route.register.root - Register root path
 * @property {string} route.register.detail - Register detail page path
 * @property {string} route.register.qr - Register QR page path
 * @property {Object} route.singpass - Singpass routes
 * @property {string} route.singpass.root - Singpass root path
 * @property {string} route.singpass.callback - Singpass callback path
 */

/** @type {FrontendConfig} */
export const frontend = {
  route: {
    root: import.meta.env.VITE_ROUTE_BASE_PATH || "/",
    legal: { root: "legal" },
    register: {
      root: "register",
      detail: "detail",
      qr: "qr",
    },
    singpass: {
      root: "singpass",
      callback: "callback",
    },
  },
};
